import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Switch from 'common/Forms/Switch';
import * as Routes from 'routes';
import I18n from '@/modules/i18n';
import styles from './RosteringStep.module.scss';

export default function ClassesStep({
  closeModal, mapCoursesPath, mappedCoursesSize, previous, next, teacherSeatsLocked, subscriber, userType,
  updateTeacherSeatsLocked,
}) {
  const [adminLocked, setAdminLocked] = useState(teacherSeatsLocked);
  const hasPARS = mappedCoursesSize > 0;
  const isAdmin = ['Admin', 'Sysadmin'].includes(userType);

  const programAssignmentCopy = () => {
    let iconClass;
    let rulesText;

    if (adminLocked) {
      if (hasPARS) {
        iconClass = 'fa fa-check-circle';
        rulesText = (
          <p>
            Congratulations! You&apos;re already set up.
            Go to <b>Program Assignments</b> to review settings and set up assignment rules.
          </p>
        );
      }
      else {
        iconClass = 'fa fa-exclamation-circle';
        rulesText = (
          <>
            <p>Admin lock is enabled and no program assignment rules have been created.</p>
            <p>
              Please create a rule to complete the auto-rostering setup.
              If you want teachers to manage their own program assignments,
              disable the setting below to finish the setup.
            </p>
          </>
        );
      }
    }
    else {
      iconClass = 'fa fa-check-circle';
      rulesText = (
        <>
          <p>Admin lock is disabled. Program assignment rules are not necessary.</p>
          <p>
            If you do not want teachers to manage their own program assignments,
            enable the setting below to finish the setup.
          </p>
        </>
      );
    }

    return (
      <>
        <p className={styles.stepSubSection}><i className={iconClass} /> Program Assignment</p>
        {rulesText}
        <Switch
          ajaxPath={Routes.plato_api_subscriber_path(subscriber.id)}
          checked={teacherSeatsLocked}
          disabled={!isAdmin}
          disabledTooltip={I18n.t('only_district_admins_can_modify')}
          displayLabelFirst={false}
          label="Manage teacher program access at the admin level"
          labelTooltip={'Enabling this setting will remove the ability for teachers to self-assign programs if ' +
            'the roster integration is on. They will be prompted to contact an admin in your account for assistance.'}
          model="subscriber"
          name="teacher_seats_locked"
          onClick={() => {
            setAdminLocked(!adminLocked);
            updateTeacherSeatsLocked(!adminLocked);
          }}
        />
      </>
    );
  };

  const modalCloseCTA = () => (
    <button
      className="btn btn--outline-purple"
      onClick={closeModal}
    >
      Close
    </button>
  );

  return (
    <div>
      <p>
        {programAssignmentCopy()}
      </p>
      <div>
        <hr />
        <footer className="!tw-justify-between">
          <button className="btn btn--link-purple" type="button" onClick={previous}>
            Back
          </button>
          <div className="tw-flex tw-gap-2">
            {modalCloseCTA()}
            {(adminLocked && !hasPARS) && (
              <a
                className="btn btn--purple"
                href={mapCoursesPath}
              >
                Go to Program Assignments
              </a>
            )}
            {((adminLocked && hasPARS) || (!adminLocked)) && (
              <button className="btn btn--purple" type="button" onClick={next}>
                Next
              </button>
            )}
          </div>
        </footer>
      </div>
    </div>
  );
}

ClassesStep.propTypes = {
  closeModal: PropTypes.func.isRequired,
  mapCoursesPath: PropTypes.string.isRequired,
  mappedCoursesSize: PropTypes.number.isRequired,
  next: PropTypes.func,
  previous: PropTypes.func,
  subscriber: PropTypes.shape({
    id: PropTypes.number
  }),
  teacherSeatsLocked: PropTypes.bool,
  updateTeacherSeatsLocked: PropTypes.func.isRequired,
  userType: PropTypes.string.isRequired,
};

ClassesStep.defaultProps = {
  next: () => {},
  previous: () => {},
  subscriber: null,
  teacherSeatsLocked: false,
};
